<template>
<div>
    <v-toolbar dark flat dense class="grey darken-3 ma-4">
        <v-toolbar-title>Адміністратори</v-toolbar-title>
        <v-btn icon @click="getDataFromApi()" title="Оновити">
            <v-icon color="grey">mdi-cached</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-account-search" label="Пошук" single-line hide-details></v-text-field>
    </v-toolbar>

    <v-data-table dark :headers="headers" :items="list" :footer-props="footerProps" :search="search" class="elevation-1 grey darken-3 ma-4" @click:row="openCard($event.member_id)">
        <template v-slot:item.permissions="{ item }">
            <span v-html="item.permissions"></span>
        </template>
        <template v-slot:no-data>
            ...
        </template>
    </v-data-table>

    <v-dialog v-model="open" scrollable max-width="600">
        <v-card>
            <v-system-bar>
                <v-spacer></v-spacer>

                <v-icon @click="open = false">mdi-close</v-icon>
            </v-system-bar>
            <v-card-title class="headline">Новий адміністратор</v-card-title>
            <v-card-text>
                <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
                    <validation-provider v-slot="{ errors, valid }" rules="required">
                        <v-autocomplete v-model="f.member" label="Користувач" persistent-hint cache-items :items="itemsMembers" :loading="isLoading" :search-input.sync="searchMembers" prepend-icon="mdi-account"></v-autocomplete>
                    </validation-provider>
                    <validation-provider v-slot="{ errors, valid }" rules="required">
                        <v-autocomplete v-model="f.permissions" label="Доступ" chips multiple persistent-hint cache-items :items="itemsGroups" :loading="isLoadingG" :search-input.sync="searchGroups" prepend-icon="mdi-format-list-bulleted-type"></v-autocomplete>
                    </validation-provider>
                    <v-btn color="orange" dark @click="passes(submitForm)" :disabled="invalid || !validated">Додати</v-btn>
                </ValidationObserver>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-btn fab bottom right color="pink" dark fixed @click.stop="open = !open">
        <v-icon>mdi-plus</v-icon>
    </v-btn>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'

import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

export default {
    data: () => ({
        f: {},
        itemsMembers: [],
        isLoading: false,
        isLoadingG: false,
        open: false,
        search: '',
        searchMembers: null,
        searchGroups: null,
        footerProps: {
            'items-per-page-options': [20, 40, 80],
            'items-per-page-text': 'на стор.'
        },
        headers: [{
                text: 'ID',
                align: 'left',
                sortable: true,
                value: 'member_id',
                selected: false,
                width: '10%',
            },
            {
                text: 'Телефон',
                align: 'left',
                sortable: true,
                value: 'phone',
                selected: true,
                width: '20%',
            },
            {
                text: 'ПІБ',
                align: 'left',
                sortable: true,
                value: 'name',
                selected: true,
                width: '20%',
            },
            {
                text: 'E-mail',
                align: 'left',
                sortable: true,
                value: 'email',
                selected: true,
                width: '20%',
            },
            {
                text: 'Доступи',
                align: 'left',
                sortable: false,
                value: 'permissions',
                selected: true,
                width: '30%',
            },
        ]

    }),
    watch: {
        searchMembers(val) {
            val && val !== this.f.member && this.queryMembersSelections(val)
        },
    },
    computed: {
        list() {
            return this.$store.state.adminpanel.adminsList
        },
        totalItems() {
            return this.$store.state.adminpanel.adminsTotal
        },
        itemsGroups() {
            return this.$store.state.adminpanel.accessGroups
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        ...mapActions(['getAdminsList', 'getMembersAutocomplete', 'getAccessGroups','addNewAdmin','setSnackbar','editAdmin']),
        queryMembersSelections(v) {
            this.isLoading = true
            this.getMembersAutocomplete(v)
                .then((data) => {
                    this.itemsMembers = data.filter(e => {
                        return (e.text || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
                    })
                    this.isLoading = false
                })
                .catch(err => console.log(err))
        },
        getDataFromApi() {
            this.getAdminsList()
        },
        openCard(id) {
            this.$router.push('/adminpanel/admins/'+id)
        },
        submitForm(){
            this.addNewAdmin(this.f)
            .then(() => {
                this.open = false
                this.f = {}
                this.getAdminsList()
            })
            .catch(
                err => this.setSnackbar(['error', err])
            )
        }
    },
    mounted() {
        this.getAdminsList()
        this.getAccessGroups()
    }
}
</script>
